import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
const SpecificMessaging = new Map([]);
export const getSpecificMessagingFunction = () => {
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  return integrationKey && SpecificMessaging.get(integrationKey) || SpecificMessaging.get(flowKey);
};